<template lang="pug">
  ShowcaseLayout(
    :title='$route.meta.title'
    :slots='slots'
  )
    template(
      slot='popular'
      v-if='popularAlbums.length'
    )
      Showcase(
        :title='$l10n("POPULAR_ALBUMS")'
        type='albums'
        url='/albums/popular'
        :items='popularAlbums'
      )
    template(
      slot='latest'
      v-if='latestAlbums.length'
    )
      Showcase(
        :title='$l10n("NEW_ALBUMS")'
        type='albums'
        url='/albums/latest'
        :items='latestAlbums'
      )
    template(
      v-for='direction in directions'
      v-if='directions.length && direction.items.length'
      :slot='direction.id'
    )
      Showcase(
        type='genres'
        :url='`/directions/${direction.id}?target=albums`'
        :title='direction.name'
        :items='getDirectionItems(direction.items)'
      )
</template>

<script>
import PageLoader from "@/services/pageLoader";
import showcasePage from "@/mixins/pages/showcase.mixin";
import errorHandler from "@/services/errorHandler";

import { mapGetters } from "vuex";
import { ITEMS_IN_SHOWCASE } from "@/constants";

const strategy = async function(route, ctx) {
  try {
    const { albums: popularAlbums = [] } = await PageLoader.getPopularAlbums({
      limit: ITEMS_IN_SHOWCASE
    });

    ctx.popularAlbumsIds = popularAlbums.map(album => album.id);
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const { albums: latestAlbums = [] } = await PageLoader.getLatestAlbums({
      limit: ITEMS_IN_SHOWCASE
    });

    ctx.latestAlbumsIds = latestAlbums.map(album => album.id);
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const { directions = [] } = await PageLoader.getDirections();

    ctx.directions = directions;
    ctx.genresIds = directions.reduce((ids, d) => [...ids, ...d.items], []);
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const { genres = [] } = await PageLoader.getGenres({ ids: ctx.genresIds });

    ctx.genres = genres;
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "AlbumsPage",
  mixins: [
    showcasePage(strategy, {
      sections: ["popularAlbumsIds", "latestAlbumsIds", "directions", "genres"]
    })
  ],
  data() {
    return {
      popularAlbumsIds: [],
      latestAlbumsIds: [],
      directions: [],
      genres: []
    };
  },
  computed: {
    ...mapGetters({
      albums: "albums/albums"
    }),
    popularAlbums() {
      return this.popularAlbumsIds.map(id => this.albums[id]);
    },
    latestAlbums() {
      return this.latestAlbumsIds.map(id => this.albums[id]);
    },
    slots() {
      return ["popular", "latest", ...this.directions.map(({ id }) => id)];
    }
  },
  methods: {
    getDirectionItems(itemsIds) {
      return itemsIds.slice(0, ITEMS_IN_SHOWCASE).map(id => {
        const genre = this.genres.find(genre => genre.id === id);
        return { ...genre, target: "albums" };
      });
    }
  }
};
</script>
